var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m62.391 19.168-18-7.515-.026-.007a.93.93 0 0 0-.125-.035 1.144 1.144 0 0 0-.113-.025.925.925 0 0 0-.118 0 1.082 1.082 0 0 0-.127 0c-.036 0-.07.016-.106.024a1.194 1.194 0 0 0-.13.036l-.025.007L26 19.008 8.38 11.653a1 1 0 0 0-1.38.923v37.333a1 1 0 0 0 .614.923l18 7.515c.013 0 .028 0 .041.008a.892.892 0 0 0 .688 0c.014 0 .028 0 .041-.008L44 50.992l17.62 7.355a1.013 1.013 0 0 0 .385.077 1 1 0 0 0 1-1V20.091a1 1 0 0 0-.614-.923zM43 39.972l-6.8-2.413 6.8-4.035zm2-7.289 16-1.418v7.55l-16 1.477zm16-3.426-16 1.418v-16.6l16 6.68zM43 31.2l-9.256 5.49L27 34.294V20.757l16-6.68zM25 20.757V34.11L9 35.982v-21.9zM9 37.995l16-1.871v19.8l-16-6.68zm18-1.579 16 5.678v7.149l-16 6.68zm18 12.827V42.3l16-1.477v15.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.7793c01824f81a0c785fc36622d1efc5.svg";
export { ForwardRef as ReactComponent };